import { InformacionVisitanteModel } from 'src/app/shared/models/informacionVisitante.model';
import { OnInit, Component, Input, OnChanges, SimpleChange, SimpleChanges } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';



@Component({
  selector: 'app-consulta-visita-modal',
  templateUrl: './consulta-visita-modal.component.html',
  styleUrls: ['./consulta-visita.component.scss']
})
export class ConsultaVisitaModalComponent implements OnInit, OnChanges {

  @Input() InformacionVisitante: InformacionVisitanteModel;
  constructor(private activeModal: NgbActiveModal) { }
  ngOnInit() {

  }

  close(tipo) {
    this.activeModal.close({ accion: tipo[1], respuesta: tipo[0] });
  }

  ngOnChanges(changes: SimpleChanges) {
  }
}
